import { NgModule } from '@angular/core';
import { KzTutorialService } from './kz-tutorial.service';
import { KzTutorialDirective } from './kz-tutorial.directive';
import { KzTutorialComponent } from './kz-tutorial/kz-tutorial.component';
import { CommonModule } from '@angular/common';
import { KzFieldModule } from '../form/field/kz-field.module';
import { KzCheckBoxModule } from '../form/checkbox/kz-checkbox.module';
import { KzLabelModule } from '../form/label/kz-label.module';

@NgModule({
  imports: [
    CommonModule,
    KzFieldModule,
    KzCheckBoxModule,
    KzLabelModule
  ],
  declarations: [
    KzTutorialDirective,
    KzTutorialComponent,
  ],
  exports: [
    KzTutorialDirective,
    KzTutorialComponent,
  ],
  providers: [
    KzTutorialService
  ]
})
export class KzTutorialModule {
}
